import {APPSYNC_ADD_QUIZZES} from '../constants'

const initialState = {quizzes: {}}

const addQuizzes = (state, quizzes) => {
  const quizHash = Array.isArray(quizzes)
    ? quizzes.reduce((acc, q) => ({...acc, [q.id]: q}), {})
    : quizzes
  return {...state, quizzes: {...state.quizzes, ...quizHash}}
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case APPSYNC_ADD_QUIZZES:
      return addQuizzes(state, action.payload)
    default:
      return state
  }
}
